import { actionTypes } from '../actions/data';

// DEFAULT STATE
export const initData = {
  levels: [],
};

// WRITES
const data = (state = { isLoading: false }, action) => {
  switch (action.type) {
    case actionTypes.START_LOADING_PERFORMANCE:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.LOAD_PERFORMANCE_SUCCESS:
      let optionDetails = [];
      let fundUnderlying = [];
      let stdPerformance = [];
      fundUnderlying = action.value.fundUnderlying;
      optionDetails = action.value.optionDetails;
      stdPerformance = action.value.stdPerformance;
      fundUnderlying = fundUnderlying.filter((x) => x.entities !== 'GTRRelWT');
      return {
        ...state,
        isLoading: false,
        fundUnderlying: fundUnderlying,
        optionDetails: optionDetails,
        stdPerformance: stdPerformance,
      };
    case actionTypes.LOAD_PERFORMANCE_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

// READS
export const getFundUnderlying = (state) => state.data.fundUnderlying;
export const getStdPerf = (state) => state.data.stdPerformance;
export const getOptionDetails = (state) => state.data.optionDetails;
export default data;


// WEBPACK FOOTER //
// ./src/reducers/data.js